import { useCallback, useState } from "react";

const readAssessmentData = () => {
  try {
    const raw = localStorage.getItem("assessmentData");
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.error("Error reading assessmentData:", error);
    return {};
  }
};

export const useAssessmentState = () => {
  const [assessmentData, setAssessmentData] = useState(readAssessmentData);
  const [sessionId, setSessionId] = useState(null);
  const [isMyRAIsActive, setIsMyRAIsActive] = useState(false);

  const updateAssessmentData = useCallback((updates) => {
    setAssessmentData((prev) => {
      const next = {
        ...prev,
        ...updates,
      };
      localStorage.setItem("assessmentData", JSON.stringify(next));
      return next;
    });
  }, []);

  const resetAssessmentData = useCallback(() => {
    setAssessmentData({});
    setSessionId(null);
    setIsMyRAIsActive(false);
    localStorage.removeItem("assessmentData");
  }, []);

  return {
    assessmentData,
    updateAssessmentData,
    resetAssessmentData,
    sessionId,
    setSessionId,
    isMyRAIsActive,
    setIsMyRAIsActive,
  };
};

export const useAssessment = useAssessmentState;
